<div class="voice-guide-list">
    <div class="voice-guide-list__header">
        <h2>{{ cityName }} Voice guide</h2>
        @if (!isFetching) {
            <button (click)="seeAll($event)" class="voice-guide-list__see-all">
                See all
            </button>
        }
    </div>

    <div class="voice-guide-list__content">
        <div class="voice-guide-list__content--description">
            Voice guided walking tours give you the freedom to explore at your own pace. You can start walking at any
            time and
            stop whenever and wherever you like, for as long as you like.
        </div>

        @if (isFetching) {
            <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
                <div class="swiper-wrapper">
                    @for (hotel of [1, 2, 3, 4]; track hotel; let idx = $index) {
                        <div class="swiper-slide">
                            <app-voice-guide-card-mobile
                                    [isFetching]="isFetching"
                            ></app-voice-guide-card-mobile>
                        </div>
                    }
                </div>
                <div class="swiper-pagination"></div>
            </div>
        } @else {
            @if (tours.length) {
                <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
                    <div class="swiper-wrapper">
                        @for (tour of tours | slice: 0:8; track tour.title; let idx = $index) {
                            <div class="swiper-slide">
                                <app-voice-guide-card-mobile
                                        [tour]="tour"
                                        [countryName]="countryName"
                                        [cityName]="cityName"
                                ></app-voice-guide-card-mobile>
                            </div>
                        }
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            } @else {
                <app-no-items-found title="EMPTY.VOICE_MAP" subtitle=""></app-no-items-found>
            }
        }
    </div>
</div>
